import React from 'react';
import './PizzaPart.scss';

const partMapping = {
  '1000000': 'full',
  '0100000': 'part-half-left',
  '0010000': 'part-half-right',
  '0001000': 'part-quarter-left-top',
  '0000100': 'part-quarter-right-top',
  '0000010': 'part-quarter-left-bottom',
  '0000001': 'part-quarter-right-bottom',
};

const PizzaPart = ({ part }) => {

  if (!part || part === '0000000'){
    return null;
  }

  return (
    <span className={`pizza-part ${partMapping[part]}`}>
      &nbsp;
    </span>
  );
};

export default PizzaPart;
